import { render, staticRenderFns } from "./ImprimirDashboard.vue?vue&type=template&id=84152160&scoped=true"
import script from "./ImprimirDashboard.vue?vue&type=script&lang=js"
export * from "./ImprimirDashboard.vue?vue&type=script&lang=js"
import style0 from "./ImprimirDashboard.vue?vue&type=style&index=0&id=84152160&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84152160",
  null
  
)

export default component.exports